import classNames from 'classnames';
import React from 'react';
import FadeIn from 'react-fade-in';
import { createUseStyles } from 'react-jss';
import Lottie from 'react-lottie-player';
import { layoutDefaults } from '../../utils/layout-defaults';
import { PrivacyNotice } from '../privacy-notice';
import iconData from './delivery.json';

function SelectAddressModalTitle({
  title,
  subTitle,
  className,
  style,
  getPrivacyPolicyFromRemote,
  analytics,
}) {
  const classes = useStyles({ subTitle });

  return (
    <div className={classNames(classes.container, className)} style={style}>
      <Lottie
        loop={false}
        play
        animationData={iconData}
        className={classes.icon}
      />
      <FadeIn delay={150}>
        <div className={classes.title}>{title}</div>
      </FadeIn>
      <FadeIn delay={200}>
        <PrivacyNotice
          analytics={analytics}
          getPrivacyPolicyFromRemote={getPrivacyPolicyFromRemote}
        />
      </FadeIn>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    marginLeft: layoutDefaults.smallHorizontalMargin,
    marginRight: layoutDefaults.smallHorizontalMargin,
    // border: "1px solid white",
  },
  icon: {
    height: 140,
    marginTop: -layoutDefaults.bigVerticalMargin,
    marginBottom: layoutDefaults.bigVerticalMargin,
    opacity: 0.8,
  },
  title: {
    fontSize: layoutDefaults.biggerFontSize + 2,
    fontWeight: 'bold',
    marginTop: -layoutDefaults.bigVerticalMargin,
  },
  subTitle: {
    fontSize: ({ subTitle }) =>
      (subTitle?.length ?? 0) < 10
        ? layoutDefaults.biggestFontSize
        : layoutDefaults.biggerFontSize,
  },
});

export { SelectAddressModalTitle };
